
export default {
    data(){
      return{
          selectIcon:require('@/assets/imgs/select-icon.svg'),
      }
    },
    props:{
        showSelect:{
            default: false
        },
        acticeIndex:{
            default:0
        },
        list:{
            default: []
        }
    },
    methods:{
        changeShow(){
            this.$emit('changeShow',!this.showSelect)
        },
        selectFn(index){
            this.$emit('changeActiveIndex',index)
        }
    }
}
